import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("cookie_consent")) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  // Réserve de l'espace en bas de page pour ne jamais masquer les boutons (mobile).
  useEffect(() => {
    document.body.style.paddingBottom = visible ? "230px" : "";
    return () => { document.body.style.paddingBottom = ""; };
  }, [visible]);

  const decide = (value) => {
    localStorage.setItem("cookie_consent", value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:max-w-md z-[60] bg-slate-900 text-white rounded-2xl shadow-2xl p-5 animate-fadeup"
      data-testid="cookie-banner"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center shrink-0">
          <Cookie className="w-5 h-5 text-[#C85A40]" />
        </div>
        <div>
          <p className="text-sm text-slate-200 leading-relaxed">
            Nous utilisons des cookies pour mesurer l'audience et améliorer votre expérience. Vous pouvez
            accepter ou refuser.{" "}
            <Link to="/confidentialite" className="text-white underline">En savoir plus</Link>.
          </p>
          <div className="flex gap-2 mt-4">
            <button
              onClick={() => decide("accepted")}
              data-testid="cookie-accept"
              className="flex-1 bg-[#2563EB] hover:bg-blue-700 text-white text-sm font-semibold px-4 py-2.5 rounded-lg transition-colors"
            >
              Accepter
            </button>
            <button
              onClick={() => decide("refused")}
              data-testid="cookie-refuse"
              className="flex-1 border border-white/20 hover:bg-white/10 text-white text-sm font-medium px-4 py-2.5 rounded-lg transition-colors"
            >
              Refuser
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
